module.exports = __webpack_public_path__ + "media/images/icons/icon-tawk-441c5ec95db1a638e3b065918a476a62.svg";